import { Component, OnInit, OnDestroy } from '@angular/core';
import { Consultant, ConsultantResource, User, UserType, Icons } from 'toolbandi-ui-lib';
import { CrudService, MessageService, SharedDataService, Breadcrumb } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConsultantresourceEditComponent } from '../consultantresource-edit/consultantresource-edit.component';

@Component({
	selector: 'app-consultantresource-view',
	templateUrl: './consultantresource-view.component.html',
	styleUrls: ['./consultantresource-view.component.scss']
})
export class ConsultantresourceViewComponent implements OnInit, OnDestroy {

	consultant: Consultant;
	loading: boolean = false;
	resource: ConsultantResource;
	tab: string;

	keys: string[];
	canvalidate: boolean;
	breadcrumb: Breadcrumb;

	error: boolean;

	constructor(
		private resourceService: CrudService<ConsultantResource>,
		private consultantService: CrudService<Consultant>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private modalService: NgbModal) {
		this.sharedDataService.currentLoggedUser.subscribe((data) => {
			if (data) {
				this.canvalidate = ((data as User).utype === UserType.admin);
			}
		});

	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			this.load(id);
			this.tab = params['tab'];
		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.resourceService.getEntity(ConsultantResource, 'consultantresource', id).subscribe(res => {
			this.resource = res;
			if (this.resource) {
				this.error = false;
				this.createKeys();
				this.consultantService.getEntity(Consultant, 'consultant', this.resource.consultantid).subscribe(con => {
					this.consultant = con;
					this.loading = false;
					this.setBreadcrumb();
				});
			} else {
				this.error = true;
				this.loading = false;
			}

		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.consultantresource'));
			this.resource = undefined;
			this.loading = false;
			this.error = true;
		});
	}


	setBreadcrumb() {

		this.breadcrumb = new Breadcrumb();
		this.breadcrumb.breadcrumbitems = [
			{ title: 'labels.consultants', url: '/consultant' },
			{ title: this.consultant.name, url: '/consultant/view/' + this.consultant.id, icon: Icons.CONSULTANT, icontooltip: 'labels.consultant' },
		];
		this.breadcrumb.addData('docinvalid', !this.resource.docvalid);
		this.breadcrumb.title = { title: 'labels.view-consultantresource', param: this.resource.fullname, icon: Icons.CONSULTANTRESOURCE, icontooltip: 'labels.consultant-resource' };
	}

	createKeys(): void {
		this.keys = Object.keys(this.resource);
		const exclude = ['fname', 'lname', 'insdate', 'moddate', 'consultantid', 'id', 'docvalid', 'daylyvalue'];
		this.keys = this.keys.filter(k => this.resource[k] && exclude.indexOf(k) < 0);
	}

	edit() {
		const modal = this.modalService.open(ConsultantresourceEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.consultantid = this.consultant.id;
		modal.componentInstance.load(this.resource.id);

		modal.result.then((newItem: ConsultantResource) => {
			this.load(this.resource.id);
		}).catch(() => { });
	}

	attachmentsChanged(): void {
		if (this.resource && this.resource.id) {
			this.resourceService.getEntity(ConsultantResource, 'consultantresource', this.resource.id).subscribe(res => {
				this.resource.docvalid = res.docvalid;
			}, ({ error }) => {

			});
		}
	}


}
